export enum VenueLayoutTableType {
  ROUND = 'ROUND',
  SQUARE = 'SQUARE',
}

export enum VenueLayoutTableSize {
  SMALL = 'SMALL',
  MEDIUM = 'MEDIUM',
  LARGE = 'LARGE',
}

export enum VenueLayoutTableEvent {
  CREATED = 'VENUE_LAYOUT_TABLE_CREATED',
  UPDATED = 'VENUE_LAYOUT_TABLE_UPDATED',
  LAYOUT_SECTION_UPDATED = 'VENUE_LAYOUT_TABLE_LAYOUT_SECTION_UPDATED',
  DELETED = 'VENUE_LAYOUT_TABLE_DELETED',
}
